/**
 * Zentrale Referenz für die modulare Homepage-Struktur.
 * Das Projekt ist derzeit JavaScript-basiert; deshalb werden die erwarteten
 * Bereiche über Konstanten und JSDoc beschrieben statt über TypeScript-Typen.
 */

export const HOMEPAGE_MODULE_KEYS = [
  "seoModule",
  "heroModule",
  "proofStripModule",
  "benefitCardsModule",
  "processStoryModule",
  "systemShowcaseModule",
  "audienceSplitModule",
  "missionModule",
  "trustModule",
  "faqModule",
  "ctaModule",
];

/**
 * @typedef {Object} HomepageContent
 * @property {Object} seoModule
 * @property {Object} heroModule
 * @property {Object} proofStripModule
 * @property {Object} benefitCardsModule
 * @property {Object} processStoryModule
 * @property {Object} systemShowcaseModule
 * @property {Object} audienceSplitModule
 * @property {Object} missionModule
 * @property {Object} trustModule
 * @property {Object} faqModule
 * @property {Object} ctaModule
 */

export const HOMEPAGE_SINGLETON_ID = "homepage";
